var AppPipesModule = (function () {
    function AppPipesModule() {
    }
    AppPipesModule.forRoot = function () {
        return {
            ngModule: AppPipesModule,
            providers: [],
        };
    };
    return AppPipesModule;
}());
export { AppPipesModule };



// WEBPACK FOOTER //
// ./src/pipes/index.module.ts.pre-build-optimizer.js